import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import TokenProgress from './TokenProgress.js';
import ToggleButton from './ToggleButton.js';
import numtoNameDict from './numToName.json';
import polygonJson from './geo_json_string.json';
import tokenDict from './token_dict.json';
import { isMobile, isTablet } from "react-device-detect";;

const App = () => {
  const [tokenId, setTokenId] = useState(null);
  const [tileNum, setTileNum] = useState(null);
  const [promptJSON, setPromptJSON] = useState(null);
  const [currentPrompt, setPrompt] = useState("");
  const [fullPromptInfo, setFullPromptInfo] = useState(null);
  const [currentTile, setCurrentTile] = useState(null);
  const [currentSubtile, setCurrentSubtile] = useState(null);
  const [zoomStatus, setZoomStatus] = useState(true);
  const [fullyZoomed, setFullyZoomed] = useState(false);
  const videoElementRef = useRef(null);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  const [video1CanPlay, setVideo1CanPlay] = useState(false);
  const [video2CanPlay, setVideo2CanPlay] = useState(false);
  const [singleTile, setSingleTile] = useState(false);
  const [tileClass, setTileClass] = useState("?");

  // const [video_path, setVideoPath] = useState("https://ipfs.io/ipfs/QmVHZwuu3YszE7FCMvtC3GeJAYYN6tU73nkptg9WHxTtVg/TODEM.384.".concat(tileNum, ".mp4") );

  const [renderNumber, setRenderNumber] = useState(56);
  const renderNumMp4Dict = {
    14: 14,
    42: 42, //384,
    56: 56,
  }

  const pathTo42_384 = "https://www.latentculture.com/tohm/render_42/data/vid/384/";
  const pathTo42_1920 = "https://www.latentculture.com/tohm/render_42/data/vid/1920/";
  const pathTo14_384 = "https://www.latentculture.com/tohm/render_14/data/vid/384/";
  const pathTo14_1920 = "https://www.latentculture.com/tohm/render_14/data/vid/1920/";
  const pathTo56_384 = "https://www.latentculture.com/tohm/render_56/data/vid/384/";
  const pathTo56_1920 = "https://www.latentculture.com/tohm/render_56/data/vid/1920/";

  //const [video_path, setVideoPath] = useState(`https://ipfs.io/ipfs/QmVHZwuu3YszE7FCMvtC3GeJAYYN6tU73nkptg9WHxTtVg/TODEM.${renderNumMp4Dict[renderNumber]}.`.concat(tileNum, ".mp4"));
  //const [video_path, setVideoPath] = useState(`https://www.latentculture.com/tohm/render_${renderNumMp4Dict[renderNumber]}/data/vid/384/`.concat(tileNum, ".mp4"));
  const [video_path, setVideoPath] = useState(null);

  const videoRef = useRef(null);
  const bgVideoRef = useRef(null);

  //console.log(video_path, renderNumber, tileNum, currentTile) 
  useEffect(() => {
    const videoElement = videoRef.current;
    const bgVideoElement = bgVideoRef.current;

    const checkCanPlay = () => {
      if (videoElement.readyState >= 3 && bgVideoElement.readyState >= 3) {
        videoElement.pause();
        bgVideoElement.pause();
        videoElement.currentTime = 0;
        bgVideoElement.currentTime = 0;
        videoElement.play();
        bgVideoElement.play();
        videoElement.removeEventListener('canplay', checkCanPlay);
        bgVideoElement.removeEventListener('canplay', checkCanPlay);
      }
    }

    videoElement.addEventListener('canplay', checkCanPlay);
    bgVideoElement.addEventListener('canplay', checkCanPlay);


    return () => {
      videoElement.removeEventListener('canplay', checkCanPlay);
      bgVideoElement.removeEventListener('canplay', checkCanPlay);
    };
  }, []);


  useEffect(() => {
    if (currentTile != null) {
      const videoElement = videoElementRef.current;
      const background_vid = document.getElementById('background-video');

      let translate = translateCenter();
      let scale = videoTransformScale();
      videoElement.style.transform = `translate(${translate[0]}px, ${translate[1]}px) scale(${scale})`
      if (video1CanPlay && video2CanPlay) {
        setTimeout(() => {
          videoElement.style.transition = `transform 1s ease 0s`;
          videoElement.style.transform = `unset`
          background_vid.style.opacity = "0"
          setHasLoaded(true);
        }, 400); // wait for 1s (1000ms) before unsetting
      }
    }
  }, [currentTile, video1CanPlay, video2CanPlay])

  // This finds the number of pixels a tile needs to move in order for its center to be alligned with the center of the map
  const translateCenter = () => {
    const background_vid = document.getElementById('background-video');
    const background_vid_rect = background_vid.getBoundingClientRect();

    const coordinates = polygonJson.features[0].features[parseInt(getNum(currentTile.name))]
      .features[0].geometry.coordinates[0];

    const x = (coordinates[0][0] + coordinates[2][0]) / 2;
    const y = Math.abs((coordinates[0][1] + coordinates[2][1]) / 2);

    const width = background_vid_rect.width;
    const height = background_vid_rect.height;
    const ratio = width / 781.25

    const center = [width / 2, height / 2];
    const distance = [(ratio * x - center[0]), (ratio * y - center[1])]

    return distance
  }

  // This find how much the video needs to shrink in order to fit on the map
  const videoTransformScale = () => {
    // Get TODEM video element
    const background_vid = document.getElementById('background-video');
    const background_vid_rect = background_vid.getBoundingClientRect();

    // Scale video to TODEM dimensions
    return (background_vid_rect.width / 781.25) / findNewScale(currentPrompt, currentTile.name)
  }


  useEffect(() => {
    if (tileNum != null) {
      let randomFeature = polygonJson.features[0].features[parseInt(tileNum)].features[0];

      // setVideoPath("https://www.latentculture.com/tohm/nft_data/1920/".concat(numtoNameDict[tileNum], '.mp4'))
      // setVideoPath("https://www.latentculture.com/tohm/nft_data/384/".concat(numtoNameDict[tileNum], '.mp4'))
      // setVideoPath("/classB-0039.mp4")
      // setVideoPath("https://ipfs.io/ipfs/QmVHZwuu3YszE7FCMvtC3GeJAYYN6tU73nkptg9WHxTtVg/TODEM.384.".concat(tileNum, ".mp4"))
      //setVideoPath(`https://ipfs.io/ipfs/QmVHZwuu3YszE7FCMvtC3GeJAYYN6tU73nkptg9WHxTtVg/TODEM.${renderNumMp4Dict[renderNumber]}.`.concat(tileNum, ".mp4"))
      setVideoPath(`https://www.latentculture.com/tohm/render_${renderNumMp4Dict[renderNumber]}/data/vid/384/`.concat(randomFeature.properties.name, ".mp4"));

      //console.log(video_path)
      var newMasterTile = {
        name: randomFeature.properties.name,
        tokenId: randomFeature.properties.tokenId,
        sentimentX_token: randomFeature.properties.sentimentX_token,
        sentimentY_token: randomFeature.properties.sentimentY_token,
        img_prompt: randomFeature.properties.img_prompt,
        wiki_token: randomFeature.properties.wiki_token,
        rgb: randomFeature.properties.rgb,
        dimensions: getDimensions(randomFeature.geometry),
      };
      setCurrentTile(newMasterTile);
      fetchData();

      videoRef.current.addEventListener('error', function () {
        videoRef.current.src = `https://www.latentculture.com/tohm/render_${renderNumMp4Dict[renderNumber]}/data/vid/384/`.concat(randomFeature.properties.names, ".mp4"); //`https://www.latentculture.com/tohm/nft_data/${renderNumMp4Dict[renderNumber]}/`.concat(numtoNameDict[tileNum], '.mp4');
      });

      setTileClass(newMasterTile.name[5])
    }
  }, [tileNum]);
  useEffect(() => {
    if (tileNum != null) {
      let randomFeature = polygonJson.features[0].features[parseInt(tileNum)].features[0];
      setVideoPath(`https://www.latentculture.com/tohm/render_${renderNumMp4Dict[renderNumber]}/data/vid/384/`.concat(randomFeature.properties.name, ".mp4"));
      videoRef.current.addEventListener('error', function () {
        videoRef.current.src = `https://www.latentculture.com/tohm/render_${renderNumMp4Dict[renderNumber]}/data/vid/384/`.concat(randomFeature.properties.names, ".mp4"); //`https://www.latentculture.com/tohm/nft_data/${renderNumMp4Dict[renderNumber]}/`.concat(numtoNameDict[tileNum], '.mp4');
      });
    }
  }, [renderNumber]);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleLeave = () => {
    let highlightBox = document.getElementsByClassName('subregion-video-box-popout')[0];
    if (highlightBox != null && highlightBox.style.visibility != 'hidden') {
      setPrompt("");
      setFullPromptInfo(null);
      highlightBox.style.visibility = 'hidden';
    }
  }

  // Using the useEffect hook to perform side effects
  useEffect(() => {
    // Accessing the first 'bounding-square' class in the document
    const popout = document.getElementsByClassName('bounding-square')[0];

    // Getting the video element by its ID
    const video = document.getElementById('video');

    // Declaring and initializing data to null
    let data = null;

    // Checking if promptJSON and currentTile are not null
    if (promptJSON != null && currentTile != null && fullyZoomed) {
      // If not null, assign the first feature of promptJSON to data
      data = promptJSON.features[0];
    }

    // Handler for the mouse move event
    const handleMouseMove = (event) => {
      // Ensuring promptJSON and currentTile are not null
      if (promptJSON != null && currentTile != null) {
        // Logging for debug purpose

        // Getting the position, size, and other properties of the video
        const videoRect = video.getBoundingClientRect();

        // Calculating the aspect ratio of the video and its container
        let videoAspectRatio = currentTile.dimensions[0] / currentTile.dimensions[1];
        let containerAspectRatio = videoRect.width / videoRect.height;

        // Initialize variables for content width, height and offsets
        let contentWidth, contentHeight, leftOffset = 0, topOffset = 0;

        // Determine the width, height and offsets based on aspect ratios
        if (containerAspectRatio > videoAspectRatio) {
          contentHeight = videoRect.height;
          contentWidth = contentHeight * videoAspectRatio;
          leftOffset = (videoRect.width - contentWidth) / 2;
        }
        else {
          contentWidth = videoRect.width;
          contentHeight = contentWidth / videoAspectRatio;
          topOffset = (videoRect.height - contentHeight) / 2;
        }

        // Calculating the actual position of the mouse pointer relative to the video
        const x = event.clientX - (videoRect.left + leftOffset);
        const y = event.clientY - videoRect.top - topOffset;
        var inAnyBox = false;

        // Looping over all the features in the data object
        for (let i = 0; i < data.features.length; i++) {
          // Getting the required details for each feature
          let thisPrompt = [
            data.features[i].features[0].id,
            data.features[i].features[0].properties.img_prompt,
            data.features[i].features[0].geometry,
            data.features[i].features[0].properties.wiki
          ];
          // Drawing the subregion box based on the feature details
          let thisBox = drawSubRegionBox(thisPrompt, currentTile.name);

          let inThisBox = pointInBox([x, y], thisBox);
          inAnyBox = inAnyBox || inThisBox;

          // Checking if the pointer is in the box
          if (inThisBox) {
            if (currentPrompt[1] != thisPrompt[1]) {
              // Rendering the prompt box if the pointer is in the box
              renderPromptBox(thisPrompt, currentTile.name, currentTile);

              // Updating the prompt state
              setPrompt(thisPrompt); //data.features[i].features[0].properties.img_prompt);

              setCurrentSubtile(data.features[i].features[0].id);
              setFullPromptInfo(thisPrompt);
            }


            if (displayedPrompt.__html != "") {
              setTimeout(() => {
                if (bottomHalf([x, y], videoRect.height - 2 * topOffset)) {
                  setPromptPosition("top");
                }
                else {
                  setPromptPosition("bottom");
                }
              }, 150);
            }
            else {
              if (bottomHalf([x, y], videoRect.height - 2 * topOffset)) {
                setPromptPosition("top");
              }
              else {
                setPromptPosition("bottom");
              }
            }
          }
        }

        if (!inAnyBox) {
          handleLeave()
        }
        else {
          let highlightBox = document.getElementsByClassName('subregion-video-box-popout')[0];
          highlightBox.style.visibility = 'unset';
        }
      }
    }

    // If data is not null
    if (data != null) {
      // If there are more than one feature, add the mousemove event listener
      if (data.features.length != 1) {
        popout.addEventListener('mousemove', handleMouseMove);
        if (fullPromptInfo !== null) {
          renderPromptBox(fullPromptInfo, currentTile.name, currentTile)
        }
      }
      else {
        if (singleTile == false) {
          setSingleTile(true);
        }
        // Otherwise, just render the prompt box for the only feature and update the prompt state
        let thisPrompt = [
          data.features[0].features[0].id,
          data.features[0].features[0].properties.img_prompt,
          data.features[0].features[0].geometry,
          data.features[0].features[0].properties.wiki
        ];

        if (thisPrompt[0] != currentPrompt[0]) {
          setPrompt(thisPrompt); //data.features[0].features[0].properties.img_prompt);
          renderPromptBox(thisPrompt, currentTile.name, currentTile)
        }
      }
    }
    // Clean-up function to remove event listener when the component is unmounted or re-rendered
    return () => {
      popout.removeEventListener('mousemove', handleMouseMove);
    };
    // Adding dependencies to the useEffect hook
  }, [currentTile, promptJSON, tileNum, fullyZoomed, windowSize, currentPrompt]);



  const setPromptPosition = (topOrBottom) => {
    let promptBox = document.getElementsByClassName('prompt-container')[0];
    if (topOrBottom === 'top') {
      promptBox.style.bottom = 'unset';
      promptBox.style.top = '0px';
      promptBox.style.width = '75%';
      promptBox.style.fontSize = '21px';
      promptBox.style.marginBottom = '12px';
      promptBox.style.padding = '12px';
    }
    else {
      promptBox.style.bottom = '0px';
      promptBox.style.top = 'unset';
      promptBox.style.width = '75%';
      promptBox.style.fontSize = '21px';
      promptBox.style.marginTop = '12px';
      promptBox.style.padding = '12px';
    }
  }

  useEffect(() => {
    const url = window.location.pathname;
    const parts = url.split('/');
    const last = parts[parts.length - 1];
    setTokenId(last);
  }, []);

  useEffect(() => {
    if (tokenId != null) {
      setTileNum(tokenDict[tokenId]);
    }
  }, [tokenId]);

  const fetchData = async () => {
    const res = await fetch(
      'https://www.latentculture.com/tohm/galactic-react/src/data/small_geojsons/' +
      numtoNameDict[tileNum] +
      '.json'
    );
    let prompt_data = await res.json();
    setPromptJSON(prompt_data);
  };

  function pointInBox(point, box) {
    const x = point[0];
    const y = point[1];
    const left = box[0];
    const top = box[1];
    const right = left + box[2];
    const bottom = top + box[3];
    return x >= left && x < right && y >= top && y < bottom;
  }

  function bottomHalf([x, y], height) {
    return y > height / 2;
  }

  function findNewScale(currentPrompt, currentTile_name) {
    const video = document.getElementsByClassName('everything-container')[0];
    const videoRect = video.getBoundingClientRect();
    let videoAspectRatio =
      currentTile.dimensions[0] / currentTile.dimensions[1];
    let containerAspectRatio = videoRect.width / videoRect.height;

    if (containerAspectRatio > videoAspectRatio) {
      let og_height = getDimensions(
        polygonJson.features[0].features[parseInt(getNum(currentTile_name))]
          .features[0].geometry
      )[1];
      let new_height = videoRect.height;
      let ratio = new_height / og_height;
      return ratio;

    }
    else {
      let og_width = getDimensions(
        polygonJson.features[0].features[parseInt(getNum(currentTile_name))]
          .features[0].geometry
      )[0];
      let new_width = videoRect.width;
      let ratio = new_width / og_width;
      return ratio;

    }
  }

  function getNum(numString) {
    let num = numString.split('-')[1];
    return num;
  }

  function getTranslation(currentPrompt, currentTile_name) {
    let parent_top_left =
      polygonJson.features[0].features[parseInt(getNum(currentTile_name))]
        .features[0].geometry.coordinates[0][0];
    let child_top_left = currentPrompt[2].coordinates[0][0];
    return [
      child_top_left[0] - parent_top_left[0],
      parent_top_left[1] - child_top_left[1],
    ];
  }

  function drawSubRegionBox(currentPrompt, currentTile_name) {
    let r = findNewScale(currentPrompt, currentTile_name);
    let topLeft = [
      getTranslation(currentPrompt, currentTile_name)[0] * r,
      getTranslation(currentPrompt, currentTile_name)[1] * r,
    ];
    let size = [
      getDimensions(currentPrompt[2])[0] * r,
      getDimensions(currentPrompt[2])[1] * r,
    ];
    return [topLeft[0], topLeft[1], size[0] + 1, size[1] + 1];
  }

  const getDimensions = (geometry) => {
    return [
      geometry.coordinates[0][3][0] - geometry.coordinates[0][0][0],
      geometry.coordinates[0][0][1] - geometry.coordinates[0][1][1],
    ];
  };

  function renderPromptBox(currentPrompt, currentTile_name, currentTile) {
    let box = drawSubRegionBox(currentPrompt, currentTile_name);
    var vidbox = document.getElementsByClassName('subregion-video-box-popout')[0];
    // vidbox.style.display = 'block';
    vidbox.style.color = "#8297ff"; //subtile_hover_color


    const videoElement = document.getElementById('video');
    const videoRect = videoElement.getBoundingClientRect();

    // Get the width and height of the video content
    let videoWidth = videoElement.videoWidth;
    let videoHeight = videoElement.videoHeight;

    // Calculate the aspect ratios of the video and the container
    // let videoAspectRatio = videoWidth / videoHeight;
    let videoAspectRatio = currentTile.dimensions[0] / currentTile.dimensions[1];

    let containerAspectRatio = videoRect.width / videoRect.height;

    let contentWidth = 0;
    let contentHeight = 0;
    let leftOffset = 0;
    let topOffset = 0;
    if (containerAspectRatio > videoAspectRatio) {
      contentHeight = videoRect.height;
      contentWidth = contentHeight * videoAspectRatio;
      leftOffset = (videoRect.width - contentWidth) / 2;
    }
    else {
      contentWidth = videoRect.width;
      contentHeight = contentWidth / videoAspectRatio;
      topOffset = (videoRect.height - contentHeight) / 2;
    }

    let translate = 'translate(';
    let translatetxt = translate.concat(
      String(parseInt(box[0]) + leftOffset),
      'px,',
      String(parseInt(box[1]) + topOffset),
      'px)'
    );
    vidbox.style.transform = translatetxt;

    vidbox.style.width = String(box[2]) + 'px';
    vidbox.style.height = String(box[3]) + 'px';
  }

  // var video_path = "https://ipfs.io/ipfs/QmVHZwuu3YszE7FCMvtC3GeJAYYN6tU73nkptg9WHxTtVg/TODEM.384.".concat(tileNum, ".mp4") 
  const handleClick = () => {
    const videoElement = videoElementRef.current;
    const background_vid = document.getElementById('background-video');
    if (hasLoaded) {
      if (zoomStatus) {
        setFullyZoomed(false);
        let translate = translateCenter();
        let scale = videoTransformScale();
        videoElement.style.transform = `translate(${translate[0]}px, ${translate[1]}px) scale(${scale})`;
        background_vid.style.opacity = "1"
      } else {
        videoElement.style.transform = "unset";
        background_vid.style.opacity = "0"
      }
      setZoomStatus(!zoomStatus);
    }
  };


  useEffect(() => {
    const videoElement = videoElementRef.current;

    const handleTransitionEnd = (event) => {
      if (event.propertyName === 'transform' && videoElement.style.transform === "unset") {
        setFullyZoomed(true);
      }
    };

    videoElement.addEventListener('transitionend', handleTransitionEnd);

    return () => {
      videoElement.removeEventListener('transitionend', handleTransitionEnd);
    };

  }, [videoElementRef]);


  function isIsolatedWord(str, word) {
    const index = str.toLowerCase().indexOf(word.toLowerCase());
    if (index === -1) {
      return false;
    }
    const before = index === 0 ? ' ' : str.charAt(index - 1);
    const after =
      index + word.length === str.length
        ? ' '
        : str.charAt(index + word.length);
    return !/\w/.test(before) && !/\w/.test(after);
  }

  function findMatchingSubstring(str1, str2) {
    if (
      str1 === str2 ||
      str1.toLowerCase() === str2 ||
      str1.toUpperCase() === str2
    ) {
      return str1;
    }
    const str2Lower = str2.toLowerCase();
    if (str1.toLowerCase().includes(str2Lower) || str1.includes(str2)) {
      const index = str1
        .toLowerCase()
        .search(new RegExp(`${str2Lower}|${str2}`));
      return str1.slice(index, index + str2.length);
    }
    return null;
  }

  const [formattedPrompt, setFormattedPrompt] = useState({ __html: "" });
  const [displayedPrompt, setDisplayedPrompt] = useState({ __html: "" });

  useEffect(() => {
    var timer
    if (displayedPrompt.__html != "") {
      // When currentPrompt changes, start a timer
      timer = setTimeout(() => {
        // After 500ms, update the displayedPrompt
        setDisplayedPrompt(formattedPrompt);
      }, 150); // Or however long your fade out transition is
    }
    else {
      setDisplayedPrompt(formattedPrompt);
    }
    // Make sure to clear the timer if the component unmounts
    return () => clearTimeout(timer);
  }, [formattedPrompt]);


  useEffect(() => {
    const textElement = document.getElementById('text-prompt');
    if (currentPrompt !== null && currentPrompt !== "" && textElement !== null) {
      // Get the text content
      var textContent = currentPrompt[1]; //textElement.textContent;
      const modifiedString = String(currentPrompt[3]).replace(/\s+/g, '_');
      let link = 'https://en.wikipedia.org/wiki/' + modifiedString;
      if (currentPrompt[3] !== null) {
        if (textContent.includes(currentPrompt[3])) {
          // Highlight the phrase with RGB(38,252,57)
          let greentext =
            '<a style="text-decoration: none; color:RGB(38,252,57)" href='.concat(
              link,
              ' target="_blank">'.concat(
                String(currentPrompt[3]),
                '</a>'
              )
            );
          textContent = textContent.replace(currentPrompt[3], greentext);
        } else if (
          findMatchingSubstring(textContent, currentPrompt[3]) !== null
        ) {
          // Highlight the phrase with RGB(38,252,57)
          let greentext =
            '<a style="text-decoration: none; color:RGB(38,252,57)" href='.concat(
              link,
              ' target="_blank">'.concat(
                String(findMatchingSubstring(textContent, currentPrompt[3])),
                '</a>'
              )
            );
          textContent = textContent.replace(
            findMatchingSubstring(textContent, currentPrompt[3]),
            greentext
          );
        } else {
          let wiki_split = currentPrompt[3].split(' ');
          let text_content_split = textContent.split(' ');
          let function_words = [
            'a',
            'an',
            'the',
            'and',
            'but',
            'or',
            'for',
            'nor',
            'so',
            'yet',
            'if',
            'of',
            'at',
            'by',
            'in',
            'to',
            'on',
            'not',
          ]; //["a", "an", "the", "and", "but", "or", "for", "nor", "so", "yet", "if", "when", "where", "while", "which", "that", "of", "at", "by", "in", "to", "from", "with", "without", "on", "upon", "over", "under", "above", "below", "between", "among", "since", "before", "after", "during", "since", "just", "only", "not", "now", "then", "still", "thus", "hence", "also", "then", "yet", "thus", "hence", "thus", "hence", "then", "yet", "thus", "hence", "with"]
          var count = 0;
          for (let i = 0; i < wiki_split.length; i++) {
            let word = wiki_split[i];
            if (!function_words.includes(word.toLowerCase())) {
              let stripped = word.replace(/[^\w\s]/gi, '');
              for (let n = 0; n < text_content_split.length; n++) {
                if (
                  isIsolatedWord(text_content_split[n], wiki_split[i]) &&
                  text_content_split[n]
                    .toLowerCase()
                    .includes(wiki_split[i].toLowerCase())
                ) {
                  var greentext =
                    '<a style="text-decoration: none; color:RGB(38,252,57)" href='.concat(
                      link,
                      ' target="_blank">'
                    );
                  greentext = greentext.concat(
                    String(text_content_split[n]),
                    '</a> '
                  );
                  text_content_split[n] = greentext;
                  count = count + 1;
                  break;
                }
                if (
                  isIsolatedWord(text_content_split[n], stripped) &&
                  text_content_split[n]
                    .toLowerCase()
                    .includes(stripped.toLowerCase())
                ) {
                  var greentext =
                    '<a style="text-decoration: none; color:RGB(38,252,57)" href='.concat(
                      link,
                      ' target="_blank">'
                    );
                  greentext = greentext.concat(
                    String(text_content_split[n]),
                    '</a> '
                  );
                  text_content_split[n] = greentext;
                  count = count + 1;
                  break;
                }
              }
            }
          }
          textContent = text_content_split.join(' ');
        }
        setFormattedPrompt({ __html: textContent });
      }
    }
  }, [currentPrompt]);

  useEffect(() => {
    const handleCanPlayThrough1 = () => {
      setVideo1CanPlay(true);
    };

    const handleCanPlayThrough2 = () => {
      setVideo2CanPlay(true);
    };

    const videoNode = videoRef.current;
    const bgVideoNode = bgVideoRef.current;

    videoNode.addEventListener('canplaythrough', handleCanPlayThrough1);
    bgVideoNode.addEventListener('canplaythrough', handleCanPlayThrough2);

    // Clean up event listeners on component unmount
    return () => {
      videoNode.removeEventListener('canplaythrough', handleCanPlayThrough1);
      bgVideoNode.removeEventListener('canplaythrough', handleCanPlayThrough2);
    };
  }, []);


  // This functions is used to set a CSS variable that scales the UI
  function adjustScale() {
    const rootStyle = document.documentElement.style;
    const boundingSquare = document.getElementsByClassName('bounding-square')[0];
    if (boundingSquare !== undefined) {
      // Get current window
      const squareWidth = boundingSquare.getBoundingClientRect().width;
      rootStyle.setProperty('--scale-factor', squareWidth / 500);
    }
  }

  window.addEventListener('resize', adjustScale);
  adjustScale(); // Initial call to set scale on load

  return (
    <>
      <div className="bounding-square">

        <TokenProgress
          tokenId={tokenId}
          tileClass={tileClass}
        >
        </TokenProgress>
        <ToggleButton
          renderNumber={renderNumber}
          setRenderNumber={setRenderNumber}
        />
        <div className="everything-container"
          onDoubleClick={isMobile || isTablet ? handleClick : null}
          onClick={isMobile || isTablet ? null : handleClick}
        >
          <div className="video-and-subregion-container"

            ref={videoElementRef} >
            <div className="subregion-video-box-popout"
              style={!fullyZoomed ? { visibility: "hidden" } : {}}
            ></div>
            <video
              ref={videoRef}
              id="video"
              muted
              loop
              autoPlay
              playsInline={true}
              src={video_path}
              type="video/mp4"
            ></video>
          </div>
        </div>

        <div
          className={`prompt-container ${displayedPrompt !== formattedPrompt ? "fade-out" : ""}`}
          style={{
            display: !fullyZoomed ? "none" : "",
            opacity:
              singleTile ? 1 :
                currentPrompt == "" || displayedPrompt !== formattedPrompt ? 0 : 1
          }}
        >
          <div id="text-prompt" dangerouslySetInnerHTML={displayedPrompt} />
        </div>
      </div>
      <video
        id="background-video"
        ref={bgVideoRef}
        muted
        loop
        playsInline
        autoPlay
        // THIS NEEDS TO BE UPDATED AS WELL
        src={`https://www.latentculture.com/todem/tile/${renderNumber}.mp4`}
        type="video/mp4"
      >
      </video>
    </>
  );
}

export default App;
